import React from 'react';
import { withTranslation, WithTranslation, Trans } from 'react-i18next';

interface TranslationResourceProps extends WithTranslation {
  message: string;
  parameters?: object;
}

class TranslationResource extends React.PureComponent<TranslationResourceProps> {
  render() {
    const { message, parameters = {} } = this.props;
    return <Trans i18nKey={message} values={parameters} />;
  }
}

const TranslationResourceWithI18n = withTranslation()(TranslationResource);

export { TranslationResourceWithI18n as TranslationResource };
